( function () {
    'use strict';
    // Henter add this script til social iconer
    e.util.addthis = {};
    e.util.addthis.init = function () {
        var addthisScript = jQuery( '.addthis_script' );
        if ( addthisScript.length > 0 ) {
            jQuery.ajax( {
                url: addthisScript.first().text(),
                dataType: 'script',
                cache: true
            } );
        }
    };
}() );
